import React from 'react';
import TabItem from "./item/TabItem";
import "./Tabs.scss";

const Tabs = props => {
  const tabs = [];

  for(let i = 0; i < props.nbQuestions; i++) {
    tabs.push(<TabItem key={i} active={i === props.currentQuestion} visible={i <= props.currentQuestion}/>);
  }

  return <div className="tabs">{tabs}</div>;
};

export default Tabs;
